module.exports = __webpack_public_path__ + "img/vip-coupon-btn-bg.16b6feb6.png";